import SponsorSection from '@/components/sponsors/SponsorSection';
import { Breadcrumb, ConfigProvider, Typography } from 'antd'
import useTranslation from '@/hooks/useTranslation';
import T from '@/components/common/T';

const { Title, Paragraph, Text } = Typography;

function SponsorsPartnersPage() {
    const { t } = useTranslation();

    return (
        <main>
            <section
                style={{
                    height: 200,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    backgroundColor: "#d5e8eb",
                    borderRadius: 8,
                    paddingBlock: 25,
                    paddingInline: 50,
                }}
            >
                <Title
                    level={2}
                    style={{
                        textTransform: "uppercase",
                        color: "#2e2525",
                        fontWeight: 600,
                        fontSize: 40,
                        marginBottom: 4,
                    }}
                >
                    <T k="sponsors_page.title" />
                </Title>
                <Breadcrumb
                    separator=">"
                    style={{ fontSize: 20, fontWeight: 500 }}
                    items={[
                        { title: t("sponsors_page.breadcrumb.home") },
                        { title: t("sponsors_page.breadcrumb.title") },
                    ]}
                />
            </section>

            <section style={{ padding: "40px 5%" }}>
                <ConfigProvider
                    theme={{
                        token: {
                            fontSize: 16,
                            lineHeight: "1.2"
                        }
                    }}
                >
                    <Paragraph>
                        <T k="sponsors_page.p1_before" />{" "}
                        <Text style={{ fontWeight: 700 }}><T k="sponsors_page.p1_bold" /></Text>{" "}
                        <T k="sponsors_page.p1_after" />
                    </Paragraph>
                    <Paragraph style={{ marginBottom: 0 }}>
                        <T k="sponsors_page.p2" />
                    </Paragraph>
                    <Paragraph>
                        <T k="sponsors_page.p3_before" />{" "}
                        <Text style={{ fontWeight: 700 }}><T k="sponsors_page.p3_bold" /></Text>
                        <T k="sponsors_page.p3_after" />
                    </Paragraph>
                    <Paragraph>
                        <T k="sponsors_page.p4" />
                    </Paragraph>
                    <Paragraph>
                        <T k="sponsors_page.p5_before" />{" "}
                        <Text style={{ fontWeight: 700 }}><T k="sponsors_page.p5_bold" /></Text>
                        <T k="sponsors_page.p5_after" />
                    </Paragraph>
                    <Paragraph style={{ marginBottom: 0 }}>
                        <T k="sponsors_page.p6" />
                    </Paragraph>
                    <Paragraph style={{ fontWeight: 700 }}>
                        <T k="sponsors_page.p7" />
                    </Paragraph>
                </ConfigProvider>
            </section>
            <section style={{ padding: "10px 4%" }}>
                <SponsorSection />
            </section>
        </main>
    )
}

export default SponsorsPartnersPage
